import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Region } from '../../interfaces/cached-content';
import { GbTheme, THEME_SIGNAL } from '../../interfaces/theme';
import { GoogleTagService } from '../../services/google-tag/google-tag.service';

@Component({
  selector: 'app-region',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './region.component.html',
  styleUrl: './region.component.scss',
})
export class RegionComponent {
  public region = input.required<Region>();

  public theme = inject(THEME_SIGNAL);

  public GbTheme = GbTheme;

  private readonly router = inject(Router);
  private readonly gtmService = inject(GoogleTagService);

  public regionSelected = output<Region>();

  onRegionClick(): void {
    this.regionSelected.emit(this.region());
    this.router.navigate(['/', this.region().slug]);

    this.gtmService.pushEvent('view_plans_page', {
      location: this.region().name,
      location_type: this.region().regionType || 'region',
    });
  }
}
